// Msal configuration parameters.
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_B2C_POLICY_SIGNIN,
        editProfile: process.env.REACT_APP_B2C_POLICY_EDIT
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_B2C_SIGNIN_AUTHORITY,
        },
        editProfile: {
            authority: process.env.REACT_APP_B2C_EDIT_AUTHORITY
        }
    },
    authorityDomain: process.env.REACT_APP_B2C_AUTHORITY_DOMAIN
}

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENT_ID,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: process.env.REACT_APP_B2C_RETURN_URI,
        postLogoutRedirectUri: process.env.REACT_APP_B2C_SIGNOUT_DESTINATION,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage", //process.env.REACT_APP_B2C_CACHE, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

export const loginRequest = {
    scopes: [process.env.REACT_APP_B2C_SCOPES]
};

export const protectedResources = {
    api: {
        scopes: [process.env.REACT_APP_B2C_SCOPES], // e.g. api://xxxxxx/access_as_user
    },
}
